import { FC, useCallback } from 'react';
import LogoImage from '../../../../assets/images/Logo.svg';
import styles from './styles.module.scss';
import ArrowBackButton from '../../../../components/ArrowBack';

type TErrorContainerProps = {
  resetError: VoidFunction;
};

const ErrorContainer: FC<TErrorContainerProps> = ({ resetError }) => {
  const handleBack = useCallback(() => {
    resetError();
  }, [resetError]);

  return (
    <div className={styles.error}>
      <ArrowBackButton className={styles.arrowBack} onClick={handleBack} />
      <div className={styles.wrapper}>
        <img src={LogoImage} alt="Логотип" className={styles.image} />
        <p className={styles.text}>
          Страница недоступна.
          <br />
          Попробуйте позже
        </p>
      </div>
    </div>
  );
};

export default ErrorContainer;
